<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>{{$t('buy_credits')}}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <thead>
                <tr>
                  <td class="col-md-1">{{$t('number')}}</td>
                  <td>{{$t('product')}}</td>
                  <td>{{$t('credits')}}</td>
                  <td v-if="customer.vat_reversed !== 1">{{$t('vat')}}</td>
                  <td v-else></td>
                  <td style="white-space: nowrap;">{{$t('price')}}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="product in productList">
                  <td>
                    <input type="number" min="1" max="100" :name="'productSelect_' + product.id" @input="productChanged($event, product.id, product.amount, product.vat)">
                  </td>
                  <td>
                    <label>
                      {{ product.short_name }} | {{ product.long_name }}
                    </label>
                  </td>
                  <td>{{product.credits}}</td>
                  <td v-if="customer.vat_reversed !== 1">{{product.vat}} %</td>
                  <td v-else></td>
                  <td style="white-space: nowrap;">{{product.amount | currency}}</td>
                </tr>
                <tr class="column-title">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{this.withoutVatTotal|currency}}</strong></td>
                </tr>
                <tr v-if="customer.vat_reversed !== 1">
                  <td>
                    <strong>
                      {{ $t('vat') }}<span v-if="this.vatPercentage">({{ this.vatPercentage }}%)</span>:
                    </strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.vatAmount|currency}}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>{{ $t('total') }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.calculatedAmount|currency}}</strong>
                  </td>
                </tr>
                <tr v-if="paymentMethod == 'paypal'">
                  <td colspan="2">
                    <strong>{{ $t('additional_payment_fee') }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.paymentFee|currency}}</strong>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <strong>{{ $t('additional_payment_fee') }}:</strong>
                  </td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>{{this.paymentFee|currency}}</strong>
                  </td>
                </tr>
                <tr style="text-align:center;">
                  <td colspan="5">
                    
                  </td>
                </tr>
                <tr style="text-align:center;">
                  <td colspan="5" class="cursor-pointer" :class="{'paymethodSelected': paymentMethod == 'creditcard'}" @click="initStripe();paymentMethod = 'creditcard'"  >
                    <img src="/static/img/creditcard.png" title="Creditcard" alt="Creditcard"><br/>
                    <small> +{{ additionalPaymentFeeAmount }} {{ additionalPaymentFeeType }} payment fees</small></td>
                  <td>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="clearfix"></div>
            <div class="cardDetailsBlock" v-if="paymentMethod == 'creditcard'">
              <h3>{{ $t('card_information') }}</h3>
              <div class="form-group">
                <input id="cardholder-name" :placeholder="$t('cardholder_name_description')" v-model="cardholderName" class="form-control required input-required" type="text">
              </div>

              <!-- placeholder for Elements -->
              <div id="card-element" class="form-control"></div>

              <!-- Used to display form errors -->
              <div id="card-errors" role="alert"></div>
              <input type="hidden" name="paymentMethodId" v-model="paymethodId" id="paymentMethodId">
          </div>
          <div class="clearfix"></div><br/>
            <button
              type="button"
              :disabled="disableBuyButton"
              class="btn btn-block btn-success"
              @click="buy()"
            >
              <i class="fas fa-arrow-alt-circle-right"></i> {{ $t('buy_credits') }}
            </button>
            <br/>
            <div class="text-center col-sm-12" v-if="redirUrl"><a :href="redirUrl">Click here to complete your payment</a></div><br/>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-header">
            <h3>{{ $t('your_details') }}</h3>
            <div class="clearfix"></div>
          </div>
          <div class="card-content">
            <table class="table table-hover">
              <thead>
                <tr>
                  <td>{{ $t('field') }}</td>
                  <td>{{ $t('value') }}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">{{ $t('your_customer_id') }}</th>
                  <td>{{ customer.id }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('name') }}</th>
                  <td>{{ customer.first_name }} {{ customer.last_name }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('address') }}</th>
                  <td>{{ customer.address_1 }} {{ customer.address_2 }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('zipcode_city') }}</th>
                  <td>{{ customer.zipcode }} {{ customer.city }}</td>
                  <td></td>
                </tr>
                <tr>
                  <th scope="row">{{ $t('current_credits') }}</th>
                  <td>{{ customer.credits }}</td>
                  <td></td>
                </tr>
                <tr v-if="customer.vat_reversed === 1">
                  <th scope="row">{{ $t('vat_reverse_charge') }}</th>
                  <td><i class="fas fa-check"></i>  {{ $t('yes') }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: function() {
    return {
      redirUrl: '',
      paymentMethod: 'creditcard',
      additionalPaymentFeeAmount: '',
      additionalPaymentFeeType: '',
      paymentFee: 0,
      disableBuyButton: false,
      productList: {},
      selectedProduct: {},
      selectedProducts: {},
      calculatedAmount: 0,
      vatAmount: 0,
      withoutVatTotal: 0,
      creditPrice: 0,
      creditPriceFormatted: 0,
      vatAmountFormatted: 0,
      creditPriceInclVAT: 0,
      vatPercentage: 0,
      customer: {},
      stripe: {},
      stripeStyle: {
            base: {
                color: '#32325d',
                lineHeight: '1.8rem'
            }
        },
        cardElement: {},
        cardholderName: '',
        paymethodId: '',
        stripeKey: ''

    };
  },
  mounted: function() {
    this.loadProducts();
    this.initStripe();
    this.getPaymentMethodAdditionalFee('stripe');
    Webservice.getUser().then(resp => {
      this.customer = resp.data;
    });

  },
  methods: {
    initStripe() {
      Webservice.getStripeKey().then((resp) => {
        if(resp.data) {
          if(!resp.data.key) {
            this.$notify({
              component: {
                template: `<span>Warning. There is an error retrieving payment instruction details. You cannot buy credits at this moment. Please contact your account manager ASAP.</span>`
              },
              icon: "fas fa-exclamation-triangle",
              type: "danger"
            });
          }
          this.stripeKey = resp.data.key;
          this.stripe = Stripe(resp.data.key); // PK NEEDED
          var elements = this.stripe.elements();
          var cardElement = elements.create('card', {style: this.stripeStyle});
          cardElement.mount('#card-element');
          this.cardElement = cardElement;
        }
      }).catch((err) => {
        swal(
          "Error",
          'We cannot continue the payment due to a missing payment key. Please contact your account manager ASAP!<br/><br/>',
          "error"
        );
      })
      
    },
    productChanged(event, productId, productPrice, productVat) {
      if(event.target.value < 1 || (event.target.value.indexOf('.') > 0 || event.target.value.indexOf(',') > 0)) {
        alert('Please enter a number (at least 1) - no comma\'s or dots please');
        return;
      }
      this.selectedProducts[productId] = {
        id: productId,
        price: productPrice,
        vat: productVat,
        number: event.target.value,
      }
      this.calcTotal();
      return;
    },

    calcTotal() {
      let calcAmount = 0; let calcVatAmount = 0;

      _.forEach(this.selectedProducts, (productItem) => {
        calcAmount += productItem.price * productItem.number;
        calcVatAmount += parseFloat(((productItem.price * productItem.number) * productItem.vat) / 100);
      });

      let productAmount = accounting.toFixed(calcAmount);
      let productVat =
        null != this.selectedProduct.vat
          ? parseFloat(this.selectedProduct.vat)
          : 0;
      let vatAmount = calcVatAmount; 
      let total = 0; let withoutVatTotal = 0;
      if (this.customer.vat_reversed === 0) {
        let multiplier = productVat * 100;
        withoutVatTotal = parseFloat(productAmount);
        total = parseFloat(productAmount) + parseFloat(vatAmount)//  accounting.toFixed((vatAmount + productAmount));
        this.vatPercentage = productVat;
        this.vatAmount = vatAmount;
      } else {
        total = productAmount;
      }
      this.withoutVatTotal = withoutVatTotal;
      this.calculatedAmount = total;
      if(this.additionalPaymentFeeAmount) {
        this.paymentFee = (total / 100) * parseInt(this.additionalPaymentFeeAmount);
      }
    },
    getPaymentMethodAdditionalFee(name) {
      // Calculate additional fees for a payment method
      axios.get(APIURL + '/transactions/paymethod-fee?paymethod_name=' + name).then((resp) => {
        if(resp.data) {
          if(resp.data.type == 'percentage') {
            this.additionalPaymentFeeAmount = resp.data.amount;
            this.additionalPaymentFeeType = 'percent';
          }
        }
      }).catch((err) => {

      })
    },
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    loadProducts() {
      Webservice.getProducts("credits").then(response => {
        this.productList = response.data;
      });
    },
    buy() {
      if(this.paymentMethod == 'creditcard' && (!this.cardholderName || !this.cardElement)) {
        swal(
          "Whoops",
          'Please enter your Card holder name and your other card details<br/><br/>',
          "warning"
        );
        return false;
      }
      
      
      if (this.selectedProduct.id || this.selectedProducts) {
        if(this.paymentMethod == 'creditcard') {
          // Process Stripe
          this.processStripe();
        } else if(this.paymentMethod == 'paypal') {
          this.processPayPal();
        }        
      } else {
        this.$notify({
          component: {
            template: `<span>`+ this.$t('no_credits_selected') + `</span>`
          },
          icon: "fas fa-exclamation-triangle",
          type: "danger"
        });
      }
    },
    processPayPal() {
      this.disableBuyButton = true;
              this.transactionProcessing = true;
                Webservice.createPayment(this.selectedProduct.id, this.selectedProducts, 'paypal')
                .then((resp) => {
                    var buyWindow = resp.data.redir_url;
                    if (
                      typeof buyWindow === "undefined" ||
                      _.includes(resp.data,"failed")
                    ) {
                      swal(
                        "Whoops",
                        this.$t('payment_failed_unknown_error') + '<br/><br/><small>' + resp.data + '</small>',
                        "warning"
                      );
                      this.transactionProcessing = false;
                    } else {
                      if(buyWindow == 'completed') {
                        this.$router.push({name : '/portal/transactions'});
                        swal({
                          title: this.$t('payment_completed'),
                          type: "success",
                          html:
                            this.$t('payment_verified_completed'),
                          showCloseButton: true,
                          focusConfirm: false
                        });
                        return true;
                      }
                      window.location.href = buyWindow;

                      swal({
                        title: this.$t('please_wait'),
                        type: "info",
                        html:
                          this.$t('your_browser_being_redirected') + ' <a href="' +
                          buyWindow +
                          '">'+ this.$t('click_here') +'</a>',
                        showCloseButton: true,
                        focusConfirm: false
                      });
                      this.ticketData = null;
                    }
                  }
                )
                .catch(
                  function(error) {
                    console.log(error)
                    if (_.includes(error.response.data, "Error 010")) {
                      swal(
                        this.$t('whoops'),
                        this.$t('an_error_occured_update_profile'),
                        "warning"
                      );
                    }
                    swal(
                      this.$t('whoops'),
                      this.$t('payment_failed_unknown_error') + '<br/><small>' + error.response.data + '</small>',
                      "warning"
                    );
                    this.buyBtnDisabled = false;
                    this.transactionProcessing = false;
                  }.bind(this)
                );
    },
    processStripe() {
      this.stripe.createPaymentMethod('card', this.cardElement, {
            billing_details: {name: this.cardholderName }
          }).then((result) => {

            if (result.error) {
                this.transactionProcessing = false;
                swal(
                        "Whoops",
                        result.error.message + '<br/><br/>Please try again',
                        "warning"
                      );
            } else {
              this.disableBuyButton = true;
              this.transactionProcessing = true;
                Webservice.createPayment(this.selectedProduct.id, this.selectedProducts, result.paymentMethod.id)
                .then((resp) => {
                    var buyWindow = resp.data.redir_url;
                    if (
                      typeof buyWindow === "undefined" ||
                      _.includes(resp.data,"failed")
                    ) {
                      swal(
                        this.$t('whoops'),
                        this.$t('payment_failed_unknown_error') + '<br/><br/><small>' + resp.data + '</small><br/><br/>Note: Wait 5 minutes before trying again. If you try to make incorrect payments too frequently, your card will be declined, and you will need to request a manual payment. <br/>Need help? Send us a ticket or an email',
                        "warning"
                      );
                      this.transactionProcessing = false;
                    } else {
                      if(buyWindow == 'completed') {
                        this.$router.push({path : '/portal/transactions'});
                        swal({
                          title: this.$t('payment_completed'),
                          type: "success",
                          html:
                            this.$t('payment_verified_completed'),
                          showCloseButton: true,
                          focusConfirm: false
                        });
                        return true;
                      } else if(buyWindow.includes('http')) { 
                        this.redirUrl = buyWindow;
                        // We got a redir url and need to be redirected
                        window.location.href = buyWindow;

                        swal({
                          title: this.$t('please_wait'),
                          type: "info",
                          html:
                            this.$t('your_browser_being_redirected') + ' <a href="' +
                            buyWindow +
                            '">'+ this.$t('click_here') +'</a>',
                          showCloseButton: true,
                          focusConfirm: false
                        });
                      }
                    }
                  }
                )
                .catch(
                  function(error) {
                    console.log(error)
                    if (_.includes(error.response.data, "Error 010")) {
                      swal(
                        this.$t('whoops'),
                        this.$t('an_error_occured_update_profile') + '</small><br/><br/> Please note: Wait 5 minutes before trying again. If you attempt incorrect payments too frequently, your card will be declined, and you will need to request manual payment. <br/>Need help? Send us a ticket or an email.',
                        "warning"
                      );
                    }
                    swal(
                      this.$t('whoops'),
                      this.$t('payment_failed_unknown_error') + '<br/><small>' + error.response.data + '</small><br/><br/>Please note: Wait 5 minutes before trying again. If you attempt incorrect payments too frequently, your card will be declined, and you will need to request manual payment. <br/>Need help? Send us a ticket or an email.',
                      "warning"
                    );
                    this.buyBtnDisabled = false;
                    this.transactionProcessing = false;
                  }.bind(this)
                );
            }
        });
    }

  },
  computed: {
    ws: () => Webservice
  }
};
</script>
<style scoped>
.paymethodSelected { border: 1px solid; background-color: #76c39c; }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/buycredit.vue